import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useUploadsInFlight from '../../hooks/upload/useUploadsInFlight';

const EXIT_MESSAGE = 'Há arquivo sendo enviado. Se sair agora, o envio para e poderá ser continuado depois. Deseja sair?';

const holdPage = (event) => {
    event.preventDefault();
    event.returnValue = EXIT_MESSAGE;
    return EXIT_MESSAGE;
};

export default function UploadExitGuard() {
    const history = useHistory();
    const { inFlight } = useUploadsInFlight();

    useEffect(() => {
        if (!inFlight) return undefined;
        const unblock = history.block(EXIT_MESSAGE);
        window.addEventListener('beforeunload', holdPage);
        return () => {
            unblock();
            window.removeEventListener('beforeunload', holdPage);
        };
    }, [inFlight, history]);

    return null;
}
